// ============================================================================
// MENTION DEV MOCK - Datos de ejemplo para desarrollo local (Fase 3/4, §7)
// ============================================================================
// En local NO hay backend con los endpoints de menciones: el front pega a la
// API de prod, que todavía no los tiene y responde 404. Para poder revisar la
// UX con `npm start` antes del deploy, MentionService cae a estos datos cuando
// el endpoint no existe (404) o falla, SIEMPRE que MENTIONS_DEV_MOCK sea true.
//
// Cómo desactivarlo:
//   - Automático: en producción (process.env.NODE_ENV === 'production') el flag
//     es false, así que el mock NUNCA se usa aunque la API fallara.
//   - Manual en local: pon FORCE_DISABLE en true (o cambia la constante a false)
//     y el front mostrará el estado real (vacío/error) en vez del mock.
// ============================================================================

const FORCE_DISABLE = false;

// Solo activo fuera de producción. Trivial de apagar con FORCE_DISABLE.
export const MENTIONS_DEV_MOCK =
  !FORCE_DISABLE && process.env.NODE_ENV !== 'production';

// Usuarios mencionables de ejemplo (forma del endpoint mentionable_users §4.1)
export const MOCK_MENTIONABLE_USERS = [
  { id: 1, nombre: 'Jonathan Vázquez', avatar: null },
  { id: 2, nombre: 'Juan Pérez', avatar: null },
  { id: 3, nombre: 'Marta Ruiz', avatar: null },
  { id: 4, nombre: 'Pablo Gómez', avatar: null },
  { id: 5, nombre: 'Laura Sánchez', avatar: null },
  { id: 6, nombre: 'Carlos Díaz', avatar: null },
  { id: 7, nombre: 'Ana Torres', avatar: null }
];

// Notificaciones de ejemplo (forma del endpoint my_notifications §4.2).
// fecha_creacion se genera relativa a "ahora" para que el tiempo relativo
// tenga sentido al revisar la UX.
function minutesAgo(min) {
  return new Date(Date.now() - min * 60 * 1000)
    .toISOString()
    .slice(0, 19)
    .replace('T', ' ');
}

export const MOCK_MY_NOTIFICATIONS = [
  {
    id: 1001,
    tipo: 'mencion',
    actor_nombre: 'Juan Pérez',
    tarea_ref: 'CERTI-106',
    tarea_nombre: 'Revisar SEO de municipios pendientes',
    mensaje: '@Marta puedes revisar el copy de los trámites antes del viernes?',
    url: '/task/detail/CERTI-106',
    leido: 0,
    fecha_creacion: minutesAgo(4)
  },
  {
    id: 1002,
    tipo: 'mencion',
    actor_nombre: 'Laura Sánchez',
    tarea_ref: 'CERTI-98',
    tarea_nombre: 'Footer SEO de la home',
    mensaje: 'Te he dejado anotadas las dudas en @Jonathan, échale un ojo.',
    url: '/task/detail/CERTI-98',
    leido: 0,
    fecha_creacion: minutesAgo(95)
  },
  {
    id: 1003,
    tipo: 'mencion',
    actor_nombre: 'Pablo Gómez',
    tarea_ref: 'CERTI-72',
    tarea_nombre: 'Migración de plantillas v2',
    mensaje: 'Cerrado por mi parte, gracias @Jonathan.',
    url: '/task/detail/CERTI-72',
    leido: 1,
    fecha_creacion: minutesAgo(1500)
  }
];
